module.exports = __webpack_public_path__ + "assets/img/detail-head-back-woman.209ead6f.png";